import req from "../../../services/psikotest/request";

class IndexPage {
  async dashboard() {
    try {
      const res = await req.get("/api/psikotest_system/dashboard");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async user_profile() {
    try {
      const res = await req.get("/api/psikotest_system/me");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update_password(data: TPSUpdatePassword) {
    try {
      const res = await req.put("/api/psikotest_system/change_password", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async get_setting() {
    try {
      const res = await req.get("/api/psikotest_system/get_setting");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update_setting(data: TPSSetting) {
    try {
      const res = await req.post("/api/psikotest_system/update_setting", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default IndexPage;
